import { render, staticRenderFns } from "./Card.vue?vue&type=template&id=41488ce4"
import script from "./Card.vue?vue&type=script&lang=js"
export * from "./Card.vue?vue&type=script&lang=js"
import style0 from "./Card.vue?vue&type=style&index=0&id=41488ce4&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\capredena\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41488ce4')) {
      api.createRecord('41488ce4', component.options)
    } else {
      api.reload('41488ce4', component.options)
    }
    module.hot.accept("./Card.vue?vue&type=template&id=41488ce4", function () {
      api.rerender('41488ce4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/DasboardReportNMV/Card.vue"
export default component.exports